/*
 * Copyright (c) SEQTA Software 2018.
 *
 * Created by simon on 2018-06-18
 */

import {createSelector} from 'reselect';
import {getRouterParams} from '../router.selectors';

/**
 * Note that "items" here refers to syllabus versions, not the items belonging to versions.
 * @param state
 * @returns {*}
 */
export const itemsSelector = state => state.syllabus && state.syllabus.versions && state.syllabus.versions.items;
export const isRetrieving = state => state.syllabus && state.syllabus.versions && state.syllabus.versions.retrieving;
export const isVersionSaving = state => state.syllabus && state.syllabus.versions && state.syllabus.versions.saving;
export const getSelectedVersionID = (state, ownProps) => getRouterParams(state, ownProps).versionID;

export const getThisVersion = createSelector(
	itemsSelector,
	getSelectedVersionID,
	(items, versionID) => items && items.find(item => item.uuid === versionID)
);

/**
 * No other version shares the selected versions name
 */
export const hasUniqueName = createSelector(
	itemsSelector,
	getThisVersion,
	(items, thisVersion) => items && thisVersion && !items.find(item => item.uuid !== thisVersion.uuid && thisVersion.name === item.name)
);

/**
 * No other version shares the selected versions number
 */
export const hasUniqueNumber = createSelector(
	itemsSelector,
	getThisVersion,
	(items, thisVersion) => items && thisVersion && !items.find(item => item.uuid !== thisVersion.uuid && thisVersion.number === item.number)
);

/**
 * The current version is valid and can be saved
 */
export const canSave = createSelector(
	hasUniqueName,
	hasUniqueNumber,
	(nameIsUnique, numberIsUnique) => nameIsUnique && numberIsUnique
);

/**
 * Get syllabus versions in number descending order.
 */
export const getVersionsSorted = createSelector(
	itemsSelector,
	// Sort versions by number descending
	items => items && items.sort((a, b) => a.number < b.number ? -1 : (a.number > b.number) ? 1 : 0).reverse()
);

/**
 * Given a list of items, flatten the nested content into a single continuous array.
 * @param syllabusItems Syllabus items, not version items.
 * @returns {object[]} Array of content objects.
 */
export const getFlattenedContentForItems = syllabusItems => syllabusItems && syllabusItems.reduce((content, item) => (
	item.content && item.content.length ? content.concat(item.content) : content
), []);


/**
 * For the list of items from props, get the flattened content.
 */
export const getFlattenedContent = createSelector(
	getThisVersion,
	version => version && version.items && getFlattenedContentForItems(version.items)
);



// WEBPACK FOOTER //
// ./src/syllabus/version.selectors.js